import {
    CandlestickTileStreamRequest,
    getCandlestickRequestWithStreamKey,
    getCandlestickStreamRequestInfosForSymbols,
} from 'widgets/candlestickTile/api/CandlestickTileStreamRequest';
import {
    StreamRequestInfo,
    WidgetCustomStreamManager,
    WidgetCustomManagedStreamOptions,
    WidgetStreamByRequestUidConfig,
    WidgetWithMarketDataRequestConfig,
} from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import State from 'store/State';
import { CandlestickTileConfigState } from 'widgets/candlestickTile/store/config/CandlestickTileConfigState';
import { WidgetStreamByRequestUidStreamManager } from 'widgets/streaming/widgetStreamManager/WidgetStreamByRequestUidStreamManager';
import { WidgetId } from 'widgets/WidgetId';
import { MarketDataRequest } from 'marketData/MarketDataRequest';
import {
    getCandlestickMarketDataRequest,
    getCandlestickMarketDataRequestForSymbols,
} from 'widgets/candlestickTile/marketData';
import { DataServices } from 'store/Services';

export const candlestickTileWidgetStreamConfig: WidgetStreamByRequestUidConfig<CandlestickTileStreamRequest> &
    WidgetWithMarketDataRequestConfig = {
    channelDestination: 'startPriceChartStream',
    managerFactory(
        options: WidgetCustomManagedStreamOptions
    ): WidgetCustomStreamManager {
        return new WidgetStreamByRequestUidStreamManager(options);
    },
    getWidgetStreamRequestInfo(
        state: State,
        services,
        id: WidgetId
    ): Promise<StreamRequestInfo<CandlestickTileStreamRequest> | undefined> {
        return getCandlestickRequestWithStreamKey(state, services, id);
    },
    getStreamRequestInfosForSymbols(
        state: State,
        services,
        symbols: string[],
        config: unknown
    ): Promise<StreamRequestInfo<CandlestickTileStreamRequest>[]> {
        return getCandlestickStreamRequestInfosForSymbols(
            state,
            services,
            symbols,
            config as CandlestickTileConfigState
        );
    },
    getMarketDataRequests(
        state: State,
        services: DataServices,
        id: WidgetId,
        _activeInputUsesOrdersStream: boolean
    ): Promise<MarketDataRequest[]> {
        return getCandlestickMarketDataRequest(state, services, id);
    },
    getMarketDataRequestForSymbols(
        state: State,
        services: DataServices,
        symbols: string[],
        config: unknown
    ): Promise<MarketDataRequest[]> {
        return getCandlestickMarketDataRequestForSymbols(
            state,
            services,
            symbols,
            config as CandlestickTileConfigState
        );
    },
};
